import { Navigate, Route, Routes } from "react-router-dom";
import { DashboardShell } from "./components/DashboardShell";
import { AlertsPage } from "./pages/AlertsPage";
import { ChangePasswordPage } from "./pages/ChangePasswordPage";
import { DevicesPage } from "./pages/DevicesPage";
import { FirmsPage } from "./pages/FirmsPage";
import { FleetsPage } from "./pages/FleetsPage";
import { AcceptInvitePage } from "./pages/AcceptInvitePage";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { MapPage } from "./pages/MapPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TargetsPage } from "./pages/TargetsPage";
import { UsersPage } from "./pages/UsersPage";
import { VehiclesPage } from "./pages/VehiclesPage";
import { OverviewPage } from "./pages/dashboard/OverviewPage";
import { ExpensesPage } from "./pages/dashboard/ExpensesPage";
import { RoutesPage } from "./pages/dashboard/RoutesPage";
import {
  BorderPage,
  DeliveryPage,
  DriverPage,
  EventsPage,
  FuelPage,
  OcrPage,
  ReportsPage,
} from "./pages/dashboard/PlaceholderPages";
import { ProductDetailPage } from "./pages/products/ProductDetailPage";
import { CookiesPage, KvkkPage, PrivacyPage } from "./pages/legal/LegalPage";
import { getToken } from "./api";

function RequireAuth({ children }: { children: React.ReactNode }) {
  if (!getToken()) return <Navigate to="/login" replace />;
  return <DashboardShell>{children}</DashboardShell>;
}

export function App() {
  return (
    <Routes>
      {/* Public marketing */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/products/:slug" element={<ProductDetailPage />} />
      <Route path="/legal/kvkk" element={<KvkkPage />} />
      <Route path="/legal/cookies" element={<CookiesPage />} />
      <Route path="/legal/privacy" element={<PrivacyPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />

      {/* Authenticated dashboard */}
      <Route path="/overview" element={<RequireAuth><OverviewPage /></RequireAuth>} />
      <Route path="/alerts" element={<RequireAuth><AlertsPage /></RequireAuth>} />
      <Route path="/map" element={<RequireAuth><MapPage /></RequireAuth>} />
      <Route path="/fleets" element={<RequireAuth><FleetsPage /></RequireAuth>} />
      <Route path="/vehicles" element={<RequireAuth><VehiclesPage /></RequireAuth>} />
      <Route path="/devices" element={<RequireAuth><DevicesPage /></RequireAuth>} />
      <Route path="/users" element={<RequireAuth><UsersPage /></RequireAuth>} />
      <Route path="/firms" element={<RequireAuth><FirmsPage /></RequireAuth>} />
      <Route path="/targets" element={<RequireAuth><TargetsPage /></RequireAuth>} />
      <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
      <Route path="/change-password" element={<RequireAuth><ChangePasswordPage /></RequireAuth>} />

      {/* Dashboard placeholder (sidebar nav) sayfaları */}
      <Route path="/events" element={<RequireAuth><EventsPage /></RequireAuth>} />
      <Route path="/driver" element={<RequireAuth><DriverPage /></RequireAuth>} />
      <Route path="/delivery" element={<RequireAuth><DeliveryPage /></RequireAuth>} />
      <Route path="/fuel" element={<RequireAuth><FuelPage /></RequireAuth>} />
      <Route path="/expenses" element={<RequireAuth><ExpensesPage /></RequireAuth>} />
      <Route path="/routes" element={<RequireAuth><RoutesPage /></RequireAuth>} />
      <Route path="/ocr" element={<RequireAuth><OcrPage /></RequireAuth>} />
      <Route path="/border" element={<RequireAuth><BorderPage /></RequireAuth>} />
      <Route path="/reports" element={<RequireAuth><ReportsPage /></RequireAuth>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
